import Vue from 'vue';
import EventBus from '_lib/EventBus';
import { addRoleUsers, revokeRoleFromUsers } from '@/api/role';
import store from '@/store';
import { ROLE_TYPES } from '@/common/constants/role';
import { decimalToHexColor } from './utils/utilsColor';
import { CHANNEL_TYPES, getChannelIcon } from './constants/channel';
import { checkMemberHasLimitations } from './utils/utilsRoom';
import { findChannelByType } from '_js/find-channel';
import { moveMember } from '_api/channel';
import { getChannelByPage } from '@/views/room/utils'

export async function getUserAddminMenu({ member, channel }) {
  let roles_list = store.getters.cur_roles_list;
  let my_roles = store.getters.cur_my_roles;
  let { cur_room_data, user_info, cur_room_data_is_big } = store.getters;
  let channel_id = channel?.channel_id;
  let $permission = Vue.prototype.$permission;
  let source_position = $permission.calcUserPosition(
    my_roles,
    user_info.user_id
  );
  let target_position = $permission.calcUserPosition(
    member.roles,
    member.user_id
  );

  // 拥有静音成员的能力

  // 高等级管理或者自己，右键会隐藏管理员操作
  let hideAdmin =
    cur_room_data.create_by == member.user_id ||
    user_info.user_id == member.user_id ||
    source_position >= target_position;
  let is_banned = false;
  if (member.ban?.until) {
    const end_time = Number(member.ban.until);
    const banned_time = end_time - Date.now() / 1000;
    is_banned = banned_time > 0;
  }
  let ignoreList = [ROLE_TYPES.everyone, ROLE_TYPES.tourist];
  let hasRole = false,
    identityManage = [];
  const hasLimitations = checkMemberHasLimitations(member, channel);
  let hiddenMoveUser = false;
  const channel_type = channel?.channel_type;
  const isServerManager = $permission.judge('ManageServer');
  const is_me = member.user_id == user_info.user_id;

  if (
    !CHANNEL_TYPES.has_audio_types.includes(channel_type) ||
    !$permission.judge('MoveUser') ||
    member.user_id == user_info.user_id ||
    !channel?.members?.find((item) => item.user_id == member.user_id)
  ) {
    hiddenMoveUser = true;
  }
  roles_list.forEach((role) => {
    if (ignoreList.includes(role.type) || source_position >= role.position)
      return;
    hasRole = true;
    let gradient = '';
    if (role.color_list && role.color_list.length == 2) {
      const colors = role.color_list.map((color) => decimalToHexColor(color));
      gradient = `linear-gradient(90deg, ${colors[0]} 0%, ${colors[1]} 100%)`;
    }
    let data = {
      label: role.name,
      icon: role.icon ? '' : 'icon-admin',
      image: role.icon,
      gradient,
      color: gradient ? '' : decimalToHexColor(role.color),
      selected: member.roles && member.roles.includes(role.id),
      confirm: () => {
        addRoleUsers(
          {},
          {
            to_user_id: member.user_id,
            department_id: role.department_id,
            role_id: role.id,
            room_id: role.department_id,
          }
        ).then(() => {
          EventBus.$emit('Refresh_Member_List');
          EventBus.$emit('Update_room_view');
        });
      },
      cancel: () => {
        revokeRoleFromUsers(
          {},
          {
            to_user_id: member.user_id,
            department_id: role.department_id,
            role_id: role.id,
            room_id: role.department_id,
          }
        ).then(() => {
          EventBus.$emit('Refresh_Member_List');
          EventBus.$emit('Update_room_view');
        });
      },
    };
    identityManage.push({
      component: 'menu-selector',
      data,
    });
  });
  
  let _user_move_page_lock  = false

  // 移动成员至 功能相关变量
  let audio_channels = [],
    last_channel_id = '';
  if (!hiddenMoveUser) {
    if (cur_room_data_is_big) {
      _user_move_page_lock = false;
      const res = await getChannelByPage({
        room_id: store.getters.cur_room_data.room_id,
        limit: 50,
        include_channel_types: [CHANNEL_TYPES.audio, CHANNEL_TYPES.temporary],
        is_password: false,
        is_private: false,
      });
      last_channel_id = res[res.length - 1].channel_id;
      audio_channels = getAudioChannelChildMenu(
        res,
        channel?.channel_id,
        member.user_id
      );
    } else {
      audio_channels = getAudioChannelChildMenu(
        store.getters.channels,
        channel?.channel_id,
        member.user_id
      );
    }
  }

  const moreMenuGroup = []

  const beforeFilterItems = [
    {
      hidden:
        !channel_id ||
        !$permission.judge('MuteUser') ||
        hasLimitations,
      component: 'menu-button',
      data: {
        label: member.mute_room
          ? '解除房间内静音'
          : '房间内麦克风静音',
      },
      onClick: () => {
        EventBus.$emit(
          'Handle_Admin_Operate',
          member.mute_room
            ? 'unmute-user-room'
            : 'mute-user-room',
          {
            to_user_id: member.user_id,
            channel_id: channel_id,
            room_id: cur_room_data.room_id,
          }
        );
      },
    },
    {
      hidden:
        !channel ||
        !channel_id ||
        !CHANNEL_TYPES.has_audio_types.includes(
          channel.channel_type
        ) ||
        !$permission.judge('MuteUser', channel_id) ||
        hasLimitations,
      component: 'menu-button',
      data: {
        label: member.mute
          ? '解除频道内静音'
          : '频道内麦克风静音',
      },
      onClick: () => {
        EventBus.$emit(
          'Handle_Admin_Operate',
          Boolean(member.mute) ? 'unmute' : 'mute',
          {
            user_id: member.user_id,
            channel_id: channel_id,
          }
        );
      },
    },
    {
      hidden: !isServerManager,
      component: 'menu-button',
      data: {
        label: '删除历史消息',
      },
      onClick: () => {
        EventBus.$dynamic(
          'DeleteUserHistoryMessageDialog',
          member
        );
      },
    },
    {
      hidden: !$permission.judgeUserPermission({
        type: 'ProhibitedMemberTemporarily',
        roles: member.roles,
        user_id: member.user_id,
        channel_id,
      }),
      component: 'menu-button',
      data: {
        label: is_banned ? '取消禁言' : '禁言用户',
      },
      onClick: () => {
        if (is_banned) {
          EventBus.$emit('CancelBanUser', member);
        } else {
          EventBus.$dynamic('BanUserDialog', true, member);
        }
      },
    },
    {
      hidden:
        !channel_id || !$permission.judge('MuteUser', channel_id),
      component: 'menu-button',
      data: {
        label: !member.mute_earphone
          ? '房间内扬声器静音'
          : '解除房间内扬声器静音',
      },
      onClick: () => {
        EventBus.$emit(
          'Handle_Admin_Operate',
          !member.mute_earphone
            ? 'mute-user-earphone'
            : 'unmute-user-earphone',
          {
            to_user_id: member.user_id,
            room_id: cur_room_data.room_id,
            channel_id: channel_id,
          }
        );
      },
    },
    {
      hidden:
        !$permission.judge('KickOutRoom') ||
        !$permission.judge('CheckInRoomBlackList'),
      component: 'menu-button',
      data: {
        label: '移出并加入房间黑名单',
        type: 'warn',
      },
      onClick: () => {
        EventBus.$dynamic('AddRoomBlack', member);
      },
    },
  ]

  if(!hideAdmin) {
    for (let item of beforeFilterItems) {
      if (item.hidden) {
        continue;
      }
      moreMenuGroup.push(item);
    }
  }
  
  return [
    {
      items: [
        {
          component: 'child-menu',
          hidden: hiddenMoveUser,
          data: {
            label: '移动成员至',
            lazyLoad: !!cur_room_data_is_big,
            lazyLoadFunc: () => {
              if (_user_move_page_lock) return;
              _user_move_page_lock = true;
              getChannelByPage({
                room_id: store.getters.cur_room_data.room_id,
                limit: 50,
                include_channel_types: [
                  CHANNEL_TYPES.audio,
                  CHANNEL_TYPES.temporary,
                ],
                is_password: false,
                is_private: false,
                anchor_channel_id: last_channel_id,
              }).then((res) => {
                if (res.length > 0) {
                  audio_channels.push(
                    ...getAudioChannelChildMenu(
                      res,
                      channel?.channel_id,
                      member.user_id
                    )
                  );
                  last_channel_id = res[res.length - 1].channel_id;
                  _user_move_page_lock = false;
                }
              });
            },
            groups: [{ items: audio_channels }],
          },
        },
        {
          hidden:
            !$permission.judgeUserPermission({
              type: 'ManageRoles',
              roles: member.roles,
              user_id: member.user_id,
              channel_id,
            }) || !hasRole,
          component: 'child-menu',
          data: {
            label: '设置成员权限',
            groups: [
              {
                items: identityManage,
              },
            ],
          },
        },
        {
          hidden: !$permission.judge('ManageNickname'),
          component: 'menu-button',
          data: {
            label: '设置房间内昵称',
          },
          onClick: () => {
            EventBus.$dynamic(
              'EditNicknameInRoom',
              member.room_nickname,
              cur_room_data.room_id,
              member.user_id
            );
          },
        },

        {
          hidden: !channel_id || !$permission.judge('MoveUser', channel_id) || is_me,
          component: 'menu-button',
          data: {
            label: '移出频道',
          },
          onClick: () => {
            EventBus.$emit('Handle_Admin_Operate', 'channel', {
              user_id: member.user_id,
              channel_id: channel_id,
              members: channel.members,
            });
          },
        },
        {
          hidden: !$permission.judge('KickOutRoom') || is_me,
          component: 'menu-button',
          data: {
            label: '移出房间',
            type: 'warn',
          },
          onClick: () => {
            EventBus.$emit('Handle_Admin_Operate', 'room', {
              user_id: member.user_id,
              bot: member.bot,
              nickname: member.nickname,
            });
          },
        },
        {
          hidden: moreMenuGroup.length === 0 || is_me,
          component: 'child-menu',
          data: {
            label: '更多成员管理',
            groups: [
              {
                items: moreMenuGroup,
              },
            ],
          },
        },
      ],
    },
  ];
}

function getAudioChannelChildMenu(
  channels,
  select_channel_id,
  to_user_id = ''
) {
  let list = findChannelByType('has_audio_types', channels);
  list = list.filter((v) => v.channel_id !== select_channel_id);
  let menu = [];
  for (let channel of list) {
    menu.push({
      component: 'menu-button',
      data: {
        label: channel.channel_name,
        icon: getChannelIcon(channel),
      },
      onClick: () => {
        moveMember(
          {},
          {
            room_id: store.getters.cur_room_data.room_id,
            channel_id: channel.channel_id,
            origin_channel_id: select_channel_id,
            to_user_ids: [to_user_id],
          }
        ).then((res) => {
          if (res.data.status === 'ok') {
            Vue.prototype.$toast.success('操作成功');
          } else if (res.data.error_type === 'no_permission') {
            EventBus.$dynamic('NoPremChannelDialog', {
              channel: channel,
              origin_channel_id: select_channel_id,
              to_user_ids: [to_user_id],
              type: 'move',
            });
          }
        });
      },
    });
  }
  return menu;
}
